var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-select', _vm._g(_vm._b({
    scopedSlots: _vm._u([_vm._l(_vm.$scopedSlots, function (_, slotName) {
      return {
        key: slotName,
        fn: function fn(slotData) {
          return [_vm._t(slotName, null, null, slotData)];
        }
      };
    })], null, true)
  }, 'v-select', _vm.$attrs, false), _vm.$listeners));
}
var staticRenderFns = []

export { render, staticRenderFns }